import React from "react";
import "./CallbackForm.scss";
import { useState } from "react";
import CallIcon from "@mui/icons-material/Call";
import { Trans, useTranslation } from "react-i18next";
import { CancelOutlined } from "@mui/icons-material";
import nextIcon from "assets/icons/carat-r-white.png";
import { useEffect } from "react";
import { apiSetFeedbackStatus } from "utils/API/TrxNowAPI";
import { devLog } from "utils/devLog";

const CALLBACK_NUMBER = process.env.REACT_APP_CALLBACK_NUMBER || "1-855-203-1423"; //SB: 1-512-580-8282

const ClickToDialLink = (props) => {
  const [phoneNumber, setPhoneNumber] = useState(props.phoneNumber);

  useEffect(() => {
    setPhoneNumber(props.phoneNumber);
  }, [props.phoneNumber]);

  return <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>;
};

const CallbackForm = (props) => {
  const { t } = useTranslation();

  const [showCallForHelp, setShowCallForHelp] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(CALLBACK_NUMBER);

  const onYesClicked = () => {
    apiSetFeedbackStatus({
      data: {
        providerRef: props.currState.CallStatusParams.ProviderRef,
        hasProviderArrvied: true,
      },
      companyParams: {
        encComGUID: props.currState.currentCompanyParams.encComGUID,
        GuidSecret: props.currState.currentCompanyParams.GuidSecret,
      },
    });
    if (typeof props.onYes === "function") {
      props.onYes();
    }
  };

  const onNoClicked = () => {
    apiSetFeedbackStatus({
      data: {
        providerRef: props.currState.CallStatusParams.ProviderRef,
        hasProviderArrvied: false,
      },
      companyParams: {
        encComGUID: props.currState.currentCompanyParams.encComGUID,
        GuidSecret: props.currState.currentCompanyParams.GuidSecret,
      },
    });
    setShowCallForHelp(true);
  };

  const onCallBtnClicked = () => {
    devLog(props.currState);
    apiSetFeedbackStatus({
      data: {
        providerRef: props.currState.CallStatusParams.ProviderRef,
        callBtnClicked: true,
      },
      companyParams: {
        encComGUID: props.currState.currentCompanyParams.encComGUID,
        GuidSecret: props.currState.currentCompanyParams.GuidSecret,
      },
    });
  };

  return (
    <div className="CallbackForm">
      {showCallForHelp === false ? (
        <div className="messageContainer">
          <div className="formContainer">
            <div className="footerContainer" style={{ display: "flex" }}>
              <div>
                <button
                  id="cancelButton"
                  type="button"
                  className="footer"
                  style={{ background: "#f4f4f4", color: "black", paddingLeft: 14 }}
                  onClick={onNoClicked}
                >
                  <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                  <span style={{ marginLeft: "0px" }}>{t("description.ConfirmServicesFlatNo")}</span>
                </button>
              </div>
              <div>
                <button onClick={onYesClicked} className="footer">
                  <span>{t("description.ConfirmServicesFlatYes")}</span>
                  <img src={nextIcon} alt="chevron" />
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="callback-form">
          <span className="cb-message">
            <span>
              <h4>{t("description.HasProviderArrivedMessage1")}</h4>
            </span>
            <hr />
            <Trans
              i18nKey="description.HasProviderArrivedMessage2"
              values={{ phoneNumber: phoneNumber }}
              components={{
                ClickToDialLink: (
                  <ClickToDialLink
                    phoneNumber={phoneNumber}
                    onClick={(e) => {
                      devLog("clicked");
                      onCallBtnClicked();
                    }}
                  />
                ),
              }}
            />
          </span>
          <div className="clickToDial-action">
            <a
              href={`tel:${phoneNumber}`}
              className="clickToDial"
              onClick={(e) => {
                devLog("clicked");
                onCallBtnClicked();
              }}
            >
              <CallIcon />
              <span>{phoneNumber}</span>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default CallbackForm;
